import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Row, Col } from 'react-flexbox-grid';
import cn from 'classnames';

import Logo from '../event_components/logo';
import Title from '../event_components/title';
import Location from '../event_components/location';
import Time from '../event_components/time';
import Details from '../event_components/details';
import AttendButton from '../event_components/attend_button';
import styles from './list.scss';

import MobileLayout from './mobile';
import PaddedComponent from './top_padder';
import GoogleLocation from '../event_components/google_location';
import EventStatus from '../event_components/event_status';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

export function ListEvent({ event, settings }) {
  const withLogoProps = { xs: 6, sm: 7, md: 7, lg: 8 };
  const withoutLogoProps = { xs: 10 };
  const hasLogo = settings.get('showEventLogo');
  const scaleProps = hasLogo ? withLogoProps : withoutLogoProps;
  return (
    <Row className={cn(styles.list, 'event')}>
      {hasLogo && (
        <Col xs={4} sm={3} md={3} lg={2}>
          <Logo event={event} settings={settings} />
        </Col>
      )}
      <Col {...scaleProps} className={styles.details}>
        <Title event={event} />
        <PaddedComponent>
          <div style={{ display: 'flex' }}>
            {settings.get('calendarType') === 'google' ? (
              <GoogleLocation event={event} />
            ) : (
              <Location event={event} className={styles.location} withIcon />
            )}
            <Time event={event} settings={settings} withIcon />
          </div>
        </PaddedComponent>
        {settings.get('showEventStatus') && (
          <PaddedComponent>
            <EventStatus event={event} settings={settings} />
          </PaddedComponent>
        )}
        <PaddedComponent>
          <Details event={event} settings={settings} />
        </PaddedComponent>
      </Col>
      {!settings.get('removeAttendButton') && (
        <Col xs={2} className="pull-right">
          <AttendButton event={event} settings={settings} />
        </Col>
      )}
    </Row>
  );
}

ListEvent.propTypes = propTypes;

function ListContainer({ events, settings, isMobile }) {
  const Component = isMobile ? MobileLayout : ListEvent;
  return (
    <div>
      {events.map(event => <Component key={event.get('id')} event={event} settings={settings} />)}
    </div>
  );
}

ListContainer.propTypes = {
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  isMobile: PropTypes.bool,
};

export default ListContainer;



// WEBPACK FOOTER //
// ./src/widget/event_layouts/list.js